import { render } from "./Tables.vue?vue&type=template&id=0c6ecc9a"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__